import { render, staticRenderFns } from "./medicion-frecuencia-ver.vue?vue&type=template&id=2f451927&scoped=true&"
import script from "./medicion-frecuencia-ver.vue?vue&type=script&lang=js&"
export * from "./medicion-frecuencia-ver.vue?vue&type=script&lang=js&"
import style0 from "./medicion-frecuencia-ver.vue?vue&type=style&index=0&id=2f451927&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f451927",
  null
  
)

export default component.exports